import api from './api';

export const getUserInfo = async () => {
    try {
        const response = await api.get('/users/me/');
        return response.data;
    } catch (error) {
        console.error('Error fetching user info:', error);
        throw error;
    }
};
